import { Component, Input } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import './string.extensions';


export interface ButtonConfig {
  buttonText?: string
  buttonEditClass?: string
  buttonSaveClass?: string
  buttonClass?: string
  buttonDisable?: boolean
  buttonVisible?: any
  row?: object

  clicked($event: Event, param?: any): Promise<boolean> | boolean
}

@Component({
  selector: 'btn-cell-renderer-editable',
  template: `
    <div ><div style="float:left" class="p-1" *ngFor="let conf of buttonConfig"> <button type="button" *ngIf="conf.buttonVisible || isButtonVisible()"
    [class]="'btn bg-danger-custom btn-icon '+conf.buttonClass" (click)="conf.clicked($event, params)">
{{conf.buttonText}}<i class="feather" [className]="'feather '+(params.data.editFlag ? conf.buttonEditClass : conf.buttonSaveClass)" disabled="conf.buttonDisable"></i>
</button></div></div>
  `,
})
export class BtnCellRendererEdit implements ICellRendererAngularComp {
  @Input() public buttonConfig: ButtonConfig[]
  public params: any;

  agInit(params: ICellRendererParams): void {
    
    this.params = params;
    this.buttonConfig = params.colDef?.cellRendererParams;
   
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    // throw new Error("Method not implemented.");
    return true;
  }

  // btnClickedHandler($event: Event) {
  //   this.params.clicked(this.params.value);
  // }
  checkCondition(visibleConf: any = {}): boolean {
    let cond = false;
    let keylist = Object.keys(visibleConf)
    if (keylist.length == 0) { return true }
    keylist.forEach((k) => {
      if (this.params.data[k] != visibleConf[k]) {
        cond = true
        return false;
      }
      return true;
    })
    console.log(cond)
    return cond;
  }

  run(condition: string) {
    let e = eval(condition.interpolate(this.params.data));

    return e;
  }

  isButtonVisible() {
    return this.params.data.reviewFlag !== false;
  }

}
